export default __webpack_public_path__ + "static/media/popup-close-dark.c8378a68.svg";